import { fg } from '@atlassian/jira-feature-gating';
import killswitch from '@jira/platform__utils-feature-gates-killswitch/src/index.tsx';
import { getLocationSearch } from './getLocationSearch.tsx';

export const isStableUIEnabledForTests = (): boolean => {
	if (!fg('jpx-870-stable-ui-for-criterion')) {
		return false;
	}

	if (killswitch('jira_stable_ui_for_tests')) {
		return false;
	}

	return getLocationSearch().includes('stableUI=1');
};
